// extracted by mini-css-extract-plugin
export default {"logoImg":"style_logoImg__qh-Wy","nameWrap":"style_nameWrap__nvxuU","name":"style_name__JWiH4"};